<template>
    <form @submit.prevent="onsubmit">
        <va-input
            class="mb-3"
            v-model="email"
            type="email"
            large
            :label="$t('auth.email')"
            :error="!!emailErrors.length"
            :error-messages="emailErrors"
        />

        <va-input
            class="mb-3"
            style="height: 60px"
            size="60"
            height="60"
            v-model="password"
            type="password"
            :label="$t('auth.password')"
            :error="!!passwordErrors.length"
            :error-messages="passwordErrors"
        />

        <!-- 滑块验证码 -->
        <div class="slider-box" :class="{ success: sliderPassed }">
            <div class="slider-bg" ref="sliderBg">
                <div
                    class="slider-progress"
                    :style="{ width: sliderLeft + sliderBtnWidth + 'px' }"
                ></div>

                <div
                    class="slider-btn"
                    :style="{ left: sliderLeft + 'px' }"
                    @mousedown.prevent="startDrag"
                    @touchstart.prevent="startDrag"
                >
                    {{ sliderPassed ? "✓" : "→" }}
                </div>

                <span class="slider-text">
                    {{
                        sliderPassed
                            ? "验证通过"
                            : "请按住滑块拖动到最右边"
                    }}
                </span>
            </div>
        </div>

        <div>
            <div style="text-align: center">
                <vxe-button
                    @click="onsubmit"
                    status="primary"
                    @keyup.enter="onsubmit"
                >
                    登录
                </vxe-button>
            </div>
        </div>
    </form>
</template>

<script>
import Qs from "qs";

export default {
    name: "login",
    data() {
        return {
            email: "",
            password: "",
            keepLoggedIn: false,
            emailErrors: [],
            passwordErrors: [],

            toastText: "邮箱或密码错误",
            toastDuration: 2500,
            toastIcon: "fa-star-o",
            toastPosition: "bottom-right",
            isToastFullWidth: false,

            text: "向右滑动->",
            accuracy: 1,

            // 滑块验证码
            sliderLeft: 0,
            sliderPassed: false,
            isDragging: false,
            startX: 0,
            sliderBtnWidth: 42,
            maxSliderLeft: 0,
        };
    },

    computed: {
        formReady() {
            return !this.emailErrors.length && !this.passwordErrors.length;
        },
    },

    beforeUnmount() {
        this.removeDragEvents();
    },

    // 如果你是 Vue3，可以把 beforeDestroy 改成 beforeUnmount
    beforeUnmount() {
        this.removeDragEvents();
    },

    methods: {
        launchToast(toastMsg) {
            this.$vaToast.init({
                message: toastMsg,
                iconClass: this.toastIcon,
                position: this.toastPosition,
                duration: Number(this.toastDuration),
                fullWidth: this.isToastFullWidth,
            });
        },

        // 开始拖动
        startDrag(e) {
            if (this.sliderPassed) {return;}

            this.isDragging = true;
            this.startX = e.clientX || e.touches[0].clientX;

            const bgWidth = this.$refs.sliderBg.offsetWidth;
            this.maxSliderLeft = bgWidth - this.sliderBtnWidth;

            document.addEventListener("mousemove", this.onDragging);
            document.addEventListener("mouseup", this.stopDrag);
            document.addEventListener("touchmove", this.onDragging);
            document.addEventListener("touchend", this.stopDrag);
        },

        // 拖动中
        onDragging(e) {
            if (!this.isDragging || this.sliderPassed) {return;}

            const currentX = e.clientX || e.touches[0].clientX;
            let moveX = currentX - this.startX;

            if (moveX < 0) {moveX = 0;}
            if (moveX > this.maxSliderLeft) {moveX = this.maxSliderLeft;}

            this.sliderLeft = moveX;

            if (moveX >= this.maxSliderLeft - 2) {
                this.sliderLeft = this.maxSliderLeft;
                this.sliderPassed = true;
                this.isDragging = false;
                this.removeDragEvents();
            }
        },

        // 结束拖动
        stopDrag() {
            if (!this.sliderPassed) {
                this.sliderLeft = 0;
            }

            this.isDragging = false;
            this.removeDragEvents();
        },

        // 移除事件
        removeDragEvents() {
            document.removeEventListener("mousemove", this.onDragging);
            document.removeEventListener("mouseup", this.stopDrag);
            document.removeEventListener("touchmove", this.onDragging);
            document.removeEventListener("touchend", this.stopDrag);
        },

        onsubmit() {
            this.emailErrors = this.email ? [] : ["请输入邮箱"];
            this.passwordErrors = this.password ? [] : ["请输入密码"];

            if (!this.formReady) {
                return;
            }

            if (!this.sliderPassed) {
                this.launchToast("请先完成滑块验证");
                return;
            }

            const params = {
                UserId: this.email,
                PassWord: this.password,
            };

            this.$api.websiteManageAPI
                .login(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        this.launchToast(res.data.Message);

                        // 登录失败后重置滑块
                        this.resetSlider();

                        return;
                    }

                    const ui = {
                        email: res.data.Data.email,
                        userID: res.data.Data.uid,
                        Id: res.data.Data.Id,
                        profilePicture: res.data.Data.profilePicture,
                        userName: res.data.Data.accountName,
                        token: res.data.Data.token,
                        userRole: res.data.Data.userRole,
                        isAdmin: res.data.Data.isAdmin,
                        jobZb: res.data.Data.jobZb,
                        jobName: res.data.Data.jobName,
                        isPC: res.data.Data.isPC,
                        otherRole: res.data.Data.otherRole,
                    };

                    this.$store.commit("updateUserInfo", ui);

                    this.$api.websiteManageAPI.setLoginLog(
                        Qs.stringify({
                            user: ui.userName,
                            msg: "CoE门户登录成功-手工",
                            type: "Login",
                        })
                    );

                    this.launchToast("登录成功");
                    this.addUserCredit(1);

                    this.$api.systemManageAPI.doSomethingAfterLogin(
                        Qs.stringify({
                            uid: ui.userID,
                            email: "",
                            currentPage: "",
                            pageSize: "",
                            searchKey: [],
                        })
                    );

                    this.$router.push({ name: "dashboard" });
                })
                .catch((error) => {
                    console.log(error);
                    this.launchToast("登录失败");

                    // 登录异常后重置滑块
                    this.resetSlider();
                });
        },

        resetSlider() {
            this.sliderLeft = 0;
            this.sliderPassed = false;
            this.isDragging = false;
        },

        // 增加积分，1登录 2发布 3点赞 4收藏
        addUserCredit(paramCode) {
            const params = {
                ArticleID: "",
                UserID: this.$store.state.userID,
                Type: paramCode,
            };

            this.$api.formsAPI
                .addUserCredit(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        this.launchToast(res.data.Message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>

<style lang="scss">
.va-input__container {
    height: 40px;
}

.va-input_labeled {
    height: 20px;
}

.va-input__label {
    height: 20px;
}

.va-input_labeled .va-input__label {
    height: 20px;
}

.code {
    margin-bottom: 10px;
}

/* 滑块验证码 */
.slider-box {
    margin: 8px 0 20px 0;
    user-select: none;
}

.slider-bg {
    position: relative;
    width: 100%;
    height: 42px;
    line-height: 42px;
    background: #f0f0f0;
    border-radius: 4px;
    overflow: hidden;
    text-align: center;
    color: #666;
    font-size: 14px;
}

.slider-progress {
    position: absolute;
    left: 0;
    top: 0;
    height: 42px;
    background: #67c23a;
    z-index: 1;
}

.slider-btn {
    position: absolute;
    top: 0;
    width: 42px;
    height: 42px;
    background: #ffffff;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    cursor: pointer;
    z-index: 3;
    text-align: center;
    font-size: 20px;
    color: #666;
    transition: background 0.2s;
}

.slider-btn:hover {
    background: #f9f9f9;
}

.slider-text {
    position: relative;
    z-index: 2;
}

.slider-box.success .slider-bg {
    background: #67c23a;
}

.slider-box.success .slider-text {
    color: #ffffff;
}

.slider-box.success .slider-btn {
    color: #67c23a;
}
</style>
